import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import PageMenu from "../../menus/PageMenu";
import { Box, Container } from "@mui/system";
import { Button } from "@mui/material";
import Team from "./Team";
import { Link as RouterLink } from "react-router-dom";
import PageContent from "../../layout/PageContent";
import RandomTestimonial from "../../reusable/RandomTestimonial";

const btnStyle={
    backgroundColor:'#265DA5',
    color:'#fff',
    borderRadius:'2rem',
    fontSize:'1rem',
    p:'0.5rem 1.5rem',
    mr:'1rem',
    mb: '.35rem',
    '&:hover':{
        backgroundColor:'#3F76BE'
    }
};

export default function OurPeople(){

    const [pageData, setPageData]=useState();

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = -130;
            const targetScrollPosition = element.offsetTop + offset;

            window.scrollTo({
                top: targetScrollPosition,
                behavior: "smooth"
            });
        }
    };

    //Fetch page
    const { isPending, isError, data, error }=useQuery(
        ['our-people'], //Query key
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/pages?slug=our-people&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            setPageData(data.data[0]);
        }
    },[data]);


    useEffect(() => {
        if (pageData) {
            const hash = window.location.hash;
            if (hash) {
                scrollToElement(hash.replace('#', ''));
            }
        }
    }, [pageData]);
    //console.log(pageData)

    return(
        <>
            <GlobalMeta/>
            <InternalBanner
                featuredImage={pageData?. _embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
            />
            <PageMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
            />
            <PageContent
                content={pageData?.content.rendered}
            />
            <Container maxWidth='xl'>
                <Box
                    sx={{
                        m:'-1rem 0 3rem 0'
                    }}
                >
                    <Button
                        sx={btnStyle}
                        onClick={()=>{
                            const team=document.getElementById("team");
                            if(team){
                                team.scrollIntoView();
                                window.scrollBy(0,-150);
                            }
                        }}
                    >
                        Meet the team
                    </Button>
                    <Button
                        sx={btnStyle}
                        component={RouterLink}
                        to='/about/careers/'
                    >
                        Join the team
                    </Button>
                </Box>
            </Container>
            <RandomTestimonial
                testimonials={pageData?.acf.testimonials}
                loading={!isPending && !pageData}
            />
            <Team
                data={pageData?.acf.team_members}
            />
        </>
    );
}